import { render, staticRenderFns } from "./LossReport.vue?vue&type=template&id=4c2577f6&"
import script from "./LossReport.vue?vue&type=script&lang=js&"
export * from "./LossReport.vue?vue&type=script&lang=js&"
import style0 from "./LossReport.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports